// The name of a class as shown in Finance: "Kindergarten" always becomes "Kleuterklas" and "Grade" becomes "Klas",
// whether the words come from the class type or are part of the name that was typed in.

type ClassFields = { className?: string | null; classType?: string | null; classGrade?: number | null };

const GENERIC = /^(kindergarten|kleuterklas|grade|groep|klas)\s*(\d+)?$/i;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Translate = (key: string, options?: any) => unknown;

export function classLabel(t: Translate, fields: ClassFields): string {
  const raw = String(fields.className ?? "").trim();
  const kindergarten = (number: string | number = "") =>
    String(t("classrooms.kindergarten", { number, defaultValue: "Kindergarten {{number}}" })).trim();
  const grade = (number: string | number = "") =>
    String(t("classrooms.grade", { number, defaultValue: "Grade {{number}}" })).trim();

  const generic = raw.match(GENERIC);
  if (!raw || generic) {
    const type = String(fields.classType ?? "").toUpperCase()
      || (/^(kindergarten|kleuterklas)/i.test(raw) ? "KINDERGARTEN" : raw ? "GRADE" : "");
    const fromGrade = fields.classGrade != null && fields.classGrade > 0 ? String(fields.classGrade) : "";
    const number = generic?.[2] ?? fromGrade;
    if (type === "KINDERGARTEN") return kindergarten(number);
    if (type === "GRADE") return grade(number);
    return raw;
  }
  // A name of its own ("Kindergarten Zon", "Grade 3/4"): only translate the words.
  return raw
    .replace(/\bkindergarten\b/gi, kindergarten())
    .replace(/\bgrade\b/gi, grade());
}
